import { Component, Input, OnInit, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { LevelTwoQuestion } from '../shared/model/ui/level-two-question';
import { FormBuilder, UntypedFormGroup, ValidatorFn, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CmElement, ContentType } from '../shared/model/cm/managed-content.model';
import { ManagedContentService } from '../shared/service/managed-content.service';
import { FormControlUtilitiesService } from '../shared/service/form-control-utilities.service';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { ChronicAcuteComponent } from '../chronic-acute/chronic-acute.component';
import { AdditionalDetailsComponent } from '../additional-details/additional-details.component';

@Component({
  selector: 'app-mhs-checkbox',
  standalone: true,
  imports: [ReactiveFormsModule, ChronicAcuteComponent, AdditionalDetailsComponent],
  templateUrl: './mhs-checkbox.component.html',
  styleUrls: ['./mhs-checkbox.component.scss'],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})

export class MhsCheckboxComponent implements OnInit, AfterViewInit {
  @Input() levelTwoQuestions: LevelTwoQuestion[];
  @Input() listType: string;
  @Input() parentForm: UntypedFormGroup;
  @Input() parentKey: string;
  @Input() controlType: string;
  @Input() selectionMaximum?: number;

  isValid: boolean = true;
  public selectedCheckboxes: string[];
  public chronicAcuteControls: string[];
  public chronicAcuteName: string;
  public showNumbers: boolean = false;
  public totalChecked: number = 0;
  public selectionLimitReached: boolean = false;
  public selectedMaximum?: number;
  public minRequired: number = 1;

  requiredElement: CmElement = this.cmService.getContentById(ContentType.ELEMENT, 'required-error');
  diagnosisElement: CmElement = this.cmService.getContentById(ContentType.ELEMENT, 'eeoi-diagnosis-error');
  diagnosisMaxLimitElement: CmElement = this.cmService.getContentById(ContentType.ELEMENT, 'eeoi-diagnosis-max-limit-error');
  
  checkboxForm: UntypedFormGroup;
  public checkboxFormValid: boolean = true;

  constructor(private fb: FormBuilder,
              private cmService: ManagedContentService,
              public formControlUtilitiesService: FormControlUtilitiesService,
              private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {

    this.selectedMaximum = this.selectionMaximum;

    if(this.controlType === 'checkboxes'){
      this.checkboxForm = new UntypedFormGroup({});
      this.showNumbers = false;
    } else {
      this.checkboxForm = new UntypedFormGroup({ }, this.requireCheckboxesToBeCheckedValidator(this.minRequired, this.selectedMaximum));
      this.showNumbers = true;
    }
    
    // Check if parent form already has this checkbox group with values
    const existingCheckboxGroup = this.parentForm?.get(this.parentKey + "-checkbox-group");
    
    if (existingCheckboxGroup) {
      // Use the existing checkbox group from parent form (it has the saved values)
      this.checkboxForm = existingCheckboxGroup as UntypedFormGroup;
    } else {
      // Create new controls with false as default
      for(let x in this.levelTwoQuestions){
        const key = this.levelTwoQuestions[x].key;
        this.checkboxForm.addControl(key, this.fb.control(false));
      }
      
      // Add the new checkbox group to parent form
      this.parentForm.addControl(this.parentKey + "-checkbox-group", this.checkboxForm);
    }

  }

  ngAfterViewInit(): void {
    // Re-sync checkbox values after view initialization (in case parent form was restored)
    setTimeout(() => {
      const checkboxGroup = this.parentForm?.get(this.parentKey + "-checkbox-group");
      if (checkboxGroup) {
        for(let x in this.levelTwoQuestions){
          const key = this.levelTwoQuestions[x].key;
          const savedValue = checkboxGroup.get(key)?.value;
          const currentControl = this.checkboxForm.get(key);
          
          
          if (currentControl && savedValue !== null && savedValue !== undefined && savedValue !== '') {
            // Convert string 'true'/'false' to boolean
            const boolValue = savedValue === true || savedValue === 'true';
            currentControl.setValue(boolValue, { emitEvent: false });
            
            // Directly update the web component's checked property
            const checkboxElement = document.querySelector(`prism-ui-checkbox[key-id="${key}"]`) as any;
            if (checkboxElement) {
              checkboxElement.checked = boolValue;
              // Also set the attribute for good measure
              if (boolValue) {
                checkboxElement.setAttribute('checked', 'true');
              } else {
                checkboxElement.removeAttribute('checked');
              }
            }
          }
        }
        this.cdr.detectChanges();
      } else {
      }
    }, 400); // Wait for parent form restoration to complete
  }

  requireCheckboxesToBeCheckedValidator(minRequired = this.minRequired, selectedMaximum = this.selectedMaximum): ValidatorFn {
    return function validate(formGroup: FormGroup) {
      let checked = 0;

      Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.controls[key];

      if (control.value === true) {
        checked++;
      }
      });

      if (checked < minRequired) {
      return {
        requireCheckboxesToBeChecked: true,
      };
      }

      if (selectedMaximum !== null && selectedMaximum !== undefined && selectedMaximum.toString() !== "" && checked > selectedMaximum) {
      return {
        aboveMaxCheckboxesToBeChecked: true,
      };
      }

      return null;
    };
      
  }
}